import React, { useEffect } from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { checkDomainsAllowed } from 'features/bonusProgram/data';

import Button from 'components/Button';
import PaginatorSwitcher from 'components/Paginator/PaginatorSwitcher/view/desktop';

import useDomains from '../../model/useDomains';

import './Domains.scss';
import Modal from 'components/ModalProvider/Modal/Modal';
import DomainsModal from './DomainsModal/DomainsModal';
import DomainsTable from './DomainsTable/DomainsTable';

const b = block('domains-desktop');

const Domains = () => {
  const locale = useSelector(state => state.locale.locale);
  const authData = useSelector(state => state.auth);
  const history = useHistory();

  const isAllowed = checkDomainsAllowed(authData);

  useEffect(() => {
    if (!isAllowed) history.replace('/');
  }, [history, isAllowed]);

  const {
    modalState,
    openModal,
    requestType,
    changeRequestType,
    domainRequests,
    agentDomains,
    handlePageChange,
    ITEMS_ON_PAGE,
    sendDomainRequest,
    totalCount,
  } = useDomains(isAllowed);

  if (!isAllowed) return null;

  return (
    <div className={b()}>
      <div className={b('header')}>
        <div className={b('header-top')}>
          <div className={b('header-top-left')}>{locale.domains}</div>
          <div className={b('header-top-right')}>
            <Button callBack={() => openModal({ isOpen: true, type: 'my-domains' })} text={locale.requestDomain} />
          </div>
        </div>
      </div>
      {/* <div className={b('header-bottom')}>
        <Button
          color={requestType === 'my-requests' ? 'primary' : 'bordered-transparent'}
          callBack={() => changeRequestType('my-requests')}
          text={locale.myDomains}
        />
        <Button
          color={requestType === 'requests' ? 'primary' : 'bordered-transparent'}
          callBack={() => changeRequestType('requests')}
          text={locale.requests}
        />
      </div> */}
      <div className={b('content')}>
        <DomainsTable
          domainRequests={domainRequests}
          agentDomains={agentDomains}
          requestType="my-requests"
          openModal={openModal}
          modalState={modalState}
          handlePageChange={handlePageChange}
          totalCount={totalCount}
        />
        <DomainsTable
          domainRequests={domainRequests}
          agentDomains={agentDomains}
          requestType="requests"
          openModal={openModal}
          modalState={modalState}
          handlePageChange={handlePageChange}
          totalCount={domainRequests.length}
        />
      </div>
      {totalCount > 0 && (
        <div className={b('pagination')}>
          <div>{`${totalCount} ${locale.records}`}</div>
          <PaginatorSwitcher
            onPageClick={handlePageChange}
            count={totalCount}
            currentPage={modalState.page - 1}
            itemsOnPage={{ value: ITEMS_ON_PAGE }}
          />
        </div>
      )}
      {modalState.isOpen && (
        <Modal
          closeFunction={() => openModal({ isOpen: false })}
          content={
            <DomainsModal
              closeFunction={() => openModal({ isOpen: false })}
              modalState={modalState}
              openModal={openModal}
              sendDomainRequest={sendDomainRequest}
            />
          }
        />
      )}
    </div>
  );
};

export default Domains;
